/**
 * Status badge for a document paused until the workspace has Boosts. A contract workspace
 * member cannot top up, so they are sent to the workspace administrator instead.
 */

import { useTranslation } from "react-i18next";
import { KiiBadge } from "@/components/kii/kii-badge";
import { usePayment } from "../lib/PaymentContext";

export default function AwaitingBoostsBadge() {
  const { t } = useTranslation();
  const { billingHidden } = usePayment();

  return (
    <KiiBadge variant="warning">
      {billingHidden
        ? t("documentDetail.statusAwaitingBoostsHidden")
        : t("documentDetail.statusAwaitingBoosts", "Awaiting boosts — will resume automatically when topped up")}
    </KiiBadge>
  );
}
